var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mx-3 mt-2"},[(_vm.dataReady=true)?_c('price-chart',{attrs:{"x":this.content[0],"y":this.content[2],"unit":this.currency}}):_vm._e(),(_vm.dataReady=true)?_c('price-chart',{attrs:{"x":this.content[0],"y":this.content[1],"unit":"szt."}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }